import {
  SET_APP_INFO,
} from '../types';

const setOSType = function setOSType(type) {
  return {
    type: SET_APP_INFO,
    payload: {
      type,
    },
  };
};


export default {
  setOSType,
};



// WEBPACK FOOTER //
// ./src/state/actions/app.js